import React from 'react';

export default function BoBroken(props) {
  return (
    <svg
      focusable="false"
      aria-hidden={true}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 157.78 173.04"
      width="315.56"
      height="346.08"
      {...props}
    >
      <ellipse
        cx="49.12"
        cy="124.71"
        rx="31.12"
        ry="3.87"
        fill="#bac8cc"
        opacity=".5"
      />
      <g data-name="8-broken_page">
        <path
          d="M31.58 123.35h-.08a1.19 1.19 0 0 1-1.11-1.27c.3-4.6.59-14.25.59-14.35a1.19 1.19 0 1 1 2.38.07c0 .1-.3 9.8-.6 14.43a1.19 1.19 0 0 1-1.18 1.12zM1.19 99.94a1.19 1.19 0 0 1-.94-1.92l9.25-12a1.191 1.191 0 1 1 1.89 1.45l-9.25 12a1.19 1.19 0 0 1-.95.47zM91.17 106.67a1.19 1.19 0 0 1-1.17-1c-.61-3.77-2.41-14.09-3.47-16.59a1.19 1.19 0 0 1 2.19-.93c1.39 3.27 3.54 16.57 3.63 17.14a1.19 1.19 0 0 1-1 1.37zM65 124.11a1.19 1.19 0 0 1-1.19-1.1c-.51-6.41-.85-14.27-.86-14.35a1.19 1.19 0 0 1 1.14-1.24 1.22 1.22 0 0 1 1.24 1.14c0 .08.34 7.89.85 14.26a1.19 1.19 0 0 1-1.09 1.28z"
          fill="#0a87c6"
        />
        <path
          fill="#6320ee"
          d="M129.79 139.42l-3.08 1.32-3.09-5.44 6.91-.73-.74 4.85zM74.78 153.33l-5.87 2.79.88 1.18.15 2.79 3.23-1.33 2.94 1.47 1.47-4.4-2.8-2.5zM116.45 153.41l-7.88-.51 1.06 3.19 2.99 4.01 2.64-4 4.38.64 3.39-5.5-5.63-1.26-.95 3.43zM130.7 152.76l-5.82-.96-.03 2.06 3.21 2.05 1.39-.75 1.31 1.88 2.72-2.41-1.7-4.13-1.08 2.26zM112.45 169.03l-2.37 1 1.87 1.13 1.31 1.88 2.69-2.63-1.67-3.91-1.83 2.53zM114.36 137.36l-7.17-.39.67-7-7.31-2.73s-1.14-7.34-1.62-7.1c-9.3 4.62-15.2 13.1-15.67 18.85-.07.88 3.65 7.64 4.79 8.1 5.36 2.14 15.13.71 24.06-4.54 2.02-1.22 2.25-5.19 2.25-5.19zm-17.43 4.75l-2 1.85-1.88-1.45 1.68-1.5.9-2.23 3.06 1.44 1.25 3.87zM155.33 147.8c.06-.28.31-2.05.31-2.05l-1.64-2.74 2.61-1.56c.5-2.46 1-4.84 1.14-5.52.32-1.36-3.51.75-6.11-.91-3.85-2.46-7-9.85-12.84-10.38-.33 0 5.59 10.62 5.59 10.62l-5.6 1.71 2.18 3.29-3.39 4.11 2.58 2s-6.77 3.7-6.57 3.72c5.68.52 11.37-4.21 15.85-4.41s5.65 3.31 5.89 2.12z"
        />
      </g>
      <path
        d="M78.46 110.36l-72.4-.59a5.09 5.09 0 0 1-2.87-5.66l13.32-74.19a5.09 5.09 0 0 1 5.83-4l74.86 12.7a5.09 5.09 0 0 1 4.15 5.94l-15.74 61.18c-.61 3.26-2.8 4.99-7.15 4.62z"
        fill="#1a8fe3"
      />
      <path fill="#fc3" d="M56.75 30.65L59.67 0l13 10.63-15.92 20.02z" />
      <path fill="#fc3" d="M56.74 30.64l13-6.73 9.55 8.53-22.55-1.8z" />
      <path fill="#fc3" d="M56.75 30.65l-17.93-9.24L49.32 15l7.43 15.65z" />
      <g data-name="8-broken_page">
        <path
          d="M59.47 91.6a.89.89 0 0 1-.82-.54 5.72 5.72 0 0 0-5.32-3.31 6.15 6.15 0 0 0-5.69 3.33.893.893 0 0 1-1.62-.75 7.79 7.79 0 0 1 7.34-4.37 7.45 7.45 0 0 1 6.93 4.39.89.89 0 0 1-.82 1.24z"
          fill="#00435e"
        />
        <path
          d="M77.81 72.37c0 5.44-4.41 8.86-9.86 8.86s-9.86-5.41-9.86-10.86 4.5-6.8 9.86-5.86 9.86 2.42 9.86 7.86z"
          fill="#fff"
        />
        <circle cx="63.34" cy="75.86" r="1.55" fill="#141104" />
        <path
          d="M29.5 72.37c0 5.44 4.41 8.86 9.86 8.86s9.86-5.41 9.86-10.86-4.24-6.45-9.86-5.86c-5.42.6-9.86 2.42-9.86 7.86z"
          fill="#fff"
        />
        <circle cx="43.42" cy="75.86" r="1.55" fill="#141104" />
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/app/ui/bo/BoBroken.js